import React from "react";
import { Card, Typography, Tag, Divider } from "antd";
import GasDocsTable from "../GasDocsTable";
import { gases } from "../../../data";

const { Title, Paragraph, Text } = Typography;

export default function VacuumSection() {
  const gas = gases.find((g) => g.key === "vacuum");

  return (
    <Card
      bordered
      style={{
        borderRadius: 12,
        padding: 16,
      }}
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Tag
            color={gas.color}
            style={{
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {gas.icon}
            {gas.label}
          </Tag>
        </span>
      }
    >
      {/* --- Таблица параметров --- */}
      <GasDocsTable gasKey="vacuum" />
      <Divider />
      {/* --- 1. Область применения --- */}
      <Paragraph>
        <Text strong>Область применения:</Text> вакуум используется для создания
        отрицательного давления в системах медицинского отсоса. Применяется в
        операционных, наркозных, палатах интенсивной терапии, родильных и
        послеоперационных палатах, перевязочных, а также в эндоскопических и
        ангиографических процедурах для удаления жидкостей, секрета и газов.
      </Paragraph>

      <Paragraph>
        <Text strong>Нормативная база:</Text> расчёт выполняется согласно{" "}
        <Text code>СП 158.13330.2014</Text> — «Здания и помещения медицинских
        организаций». Производительность вакуумной станции определяется по
        суммарной расчётной потребности с учётом коэффициента одновременности,
        зависящего от типа помещения.
      </Paragraph>

      <Divider />

      {/* --- 2. Формула расчёта --- */}
      <Paragraph>
        <Text strong>Формула расчёта:</Text>
      </Paragraph>

      <Paragraph
        code
        style={{
          padding: "8px 12px",
          borderRadius: 6,
          display: "inline-block",
        }}
      >
        V<sub>vac</sub> = Vₘ × N<sub>vac</sub> × K<sub>vac</sub>
      </Paragraph>
    
    <Paragraph type="secondary">
        где <Text strong>Vₘ</Text> — номинальный расход от одной точки отсоса,
        <Text strong> N<sub>vac</sub></Text> — количество точек,
        <Text strong> K<sub>vac</sub></Text> — коэффициент одновременности:
        <ul style={{ marginLeft: 20 }}>
          <li>
            0.7 — операционные, реанимации, родовые, послеоперационные, ИТ;
          </li>
          <li>
            0.3 — палаты, перевязочные, эндоскопии, новорождённые.
          </li>
        </ul>
      </Paragraph>


      <Divider />

      {/* --- 3. Единицы измерения --- */}
      <Paragraph>
        <Text strong>Единицы измерения:</Text> {gas.unit}
      </Paragraph>

      <Divider />

      {/* --- 4. Состав системы --- */}
      <Title level={5}>Состав системы централизованного обеспечения вакуумом</Title>
      <Paragraph>
        Система состоит из источника вакуума —{" "}
        <Text strong>медицинской вакуумной станции</Text> — и сети трубопроводов
        с конечными элементами газовой разводки (вакуумными розетками).
      </Paragraph>

      <Paragraph>
        Подводка вакуумных трубопроводов предусматривается в:
        <ul style={{ marginLeft: 20 }}>
          <li>операционные и наркозные;</li>
          <li>реанимационные и палаты интенсивной терапии;</li>
          <li>родовые, послеоперационные, ожоговые;</li>
          <li>перевязочные и процедурные ангиографии, эндоскопии, бронхоскопии;</li>
          <li>
            палаты на 1 и 2 койки (по проекту — допускается в палатах {"\u003e"} 2 коек);
          </li>
          <li>палаты для новорождённых и недоношенных детей.</li>
        </ul>
      </Paragraph>

      <Divider />

      {/* --- 5. Состав вакуумной станции --- */}
      <Title level={5}>Состав и требования к вакуумной станции</Title>
      <Paragraph>
        В состав станции должно входить:
        <ul style={{ marginLeft: 20 }}>
          <li>не менее двух вакуумных насосов (один резервный);</li>
          <li>не менее двух антибактериальных фильтров (один резервный);</li>
          <li>
            резервный насос в расчёт производительности не включается — она должна
            быть не ниже суммарной расчётной потребности в вакууме.
          </li>
        </ul>
      </Paragraph>

      

      

      <Divider />

      {/* --- 6. Размещение станции --- */}
      <Title level={5}>Размещение и условия эксплуатации станции</Title>
      <Paragraph>
        Вакуумные станции размещаются в помещениях подвала или цокольного этажа 
        под второстепенными помещениями (вестибюли, гардеробы, склады белья и т.п.).
      </Paragraph>

      <Paragraph>
        Температура воздуха должна быть в пределах от 10 до 35 °C. Для нормальной
        работы необходимо предусмотреть вентиляцию, рассчитываемую по формуле:
      </Paragraph>

      <Paragraph
        code
        style={{
          padding: "8px 12px",
          borderRadius: 6,
          display: "inline-block",
        }}
      >
        Q<sub>v</sub> = P<sub>v</sub> / (1.16 × ΔT)
      </Paragraph>

      <Paragraph type="secondary">
        где Q<sub>v</sub> — подача воздуха на вентиляцию (м³/с), 
        P<sub>v</sub> — тепловыделение (кВт), ΔT — допустимое повышение температуры.
      </Paragraph>

      <Divider />

      {/* --- 7. Требования к выбросу и шуму --- */}
      <Title level={5}>Отвод воздуха и шумовые параметры</Title>
      <Paragraph>
        <ul style={{ marginLeft: 20 }}>
          <li>
            Отсасываемый воздух выбрасывается за пределы здания на высоту не менее 2 м от уровня земли.
          </li>
          <li>
            Уровень шума в помещении вакуумных насосов не должен превышать 75 дБ (А).
            При превышении предусматриваются меры шумоглушения и изоляции смежных помещений.
          </li>
        </ul>
      </Paragraph>

      <Divider />

      {/* --- 8. Таблица параметров --- */}
      <Paragraph>
        <Text strong>Номинальные расходы от одной точки вакуума:</Text>
      </Paragraph>

      <GasDocsTable gasKey="vacuum" />

      <Paragraph
        type="secondary"
        style={{
          marginTop: 16,
          fontStyle: "italic",
          fontSize: 13,
          lineHeight: 1.6,
        }}
      >
        Значения и коэффициенты приведены по СП 158.13330.2014. Расчёт
        производительности станции выполняется без учёта резервного насоса,
        а фактическая производительность должна обеспечивать всю расчётную
        нагрузку в режиме максимального потребления.
      </Paragraph>
    </Card>
  );
}
